// ECDD config for badges and display — data comes from /api/ecdd

export const ECDD_STATUS_CONFIG = {
  open: { label: 'Open', color: '#0a5169', bg: '#e8f2f6', border: '#b8d8e8' },
  pending_approval: { label: 'Pending Approval', color: '#ca8a04', bg: '#fefce8', border: '#fef08a' },
  approved_monitoring: { label: 'Approved — Monitoring', color: '#16a34a', bg: '#f0fdf4', border: '#bbf7d0' },
  approved_smr: { label: 'Approved — SMR Pending', color: '#dc2626', bg: '#fef2f2', border: '#fecaca' },
  closed: { label: 'Closed', color: '#16a34a', bg: '#f0fdf4', border: '#bbf7d0' },
}

export const ECDD_TRIGGER_CONFIG = {
  pep: { label: 'PEP', color: '#dc2626', bg: '#fef2f2', border: '#fecaca' },
  screening: { label: 'Screening', color: '#8b5cf6', bg: '#f5f3ff', border: '#ddd6fe' },
  alert: { label: 'Alert', color: '#ea580c', bg: '#fff7ed', border: '#fed7aa' },
  manual: { label: 'Manual', color: '#64748b', bg: '#f3f4f6', border: '#e5e7eb' },
  risk: { label: 'Risk Score', color: '#ca8a04', bg: '#fefce8', border: '#fef08a' },
}

export const ECDD_RESOLUTION_CONFIG = {
  satisfactory: { label: 'Satisfactory', color: '#16a34a' },
  enhanced_monitoring: { label: 'Enhanced Monitoring', color: '#ca8a04' },
  escalated_smr: { label: 'Escalated → SMR', color: '#dc2626' },
}

